import { useState } from "react";

import { makeGetApiCall, makePostApiCall } from "../../shared/makeApiCall";
import ModelErrorComponent from "../../components/modals/ModelErrorComponent";

export function DashboardViewModel(logout) {
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });

  const [statsSummaries, setStatsSummaries] = useState([]);
  const [productInventoryStats, setProductInventoryStats] = useState([]);
  const [topSellingItemsStats, setTopSellingItemsStats] = useState([]);
  const [topSalesPersonsStats, setTopSalesPersonsStats] = useState([]);
  const [chartData, setChartData] = useState({});

  const getStatsSummaries = async function () {
    let callResult = await makeGetApiCall("fetchStatsSummaries");

    if (callResult.success) {
      setStatsSummaries(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not load stats");
    }
  };

  const getProductInventoryStats = async function () {
    let callResult = await makeGetApiCall("fetchInventoryStats");

    if (callResult.success) {
      setProductInventoryStats(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not load stats");
    }
  };

  const getTopSellingItemsStats = async function () {
    let callResult = await makeGetApiCall("fetchTopSellingItemsStats");

    if (callResult.success) {
      setTopSellingItemsStats(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not load stats");
    }
  };

  const getChartData = async function () {
    let callResult = await makeGetApiCall("fetchChartData");

    if (callResult.success) {
      setChartData(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not load stats");
    }
  };

  const fetchTopFiveSalesPersons = async function () {
    let callResult = await makeGetApiCall("fetchTopFiveSalesPersons");

    if (callResult.success) {
      setTopSalesPersonsStats(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not load stats");
    }
  };

  const showErrorModal = (title, subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title={title}
        />
      ),
      open: true,
    });
  };

  return {
    getStatsSummaries,
    getProductInventoryStats,
    getTopSellingItemsStats,
    fetchTopFiveSalesPersons,
    getChartData,
    statsSummaries,
    productInventoryStats,
    topSellingItemsStats,
    topSalesPersonsStats,
    chartData,
    emptyModal,
    setEmptyModelOpen,
  };
}
